import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';


const Cadastro = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');

    // Redireciona para "/" se o usuário já estiver logado
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                navigate("/");
            }
        });

        // Limpeza do listener
        return () => unsubscribe();
    }, [navigate]);

    const onSubmit = async (e) => {
        e.preventDefault()

        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
             
                navigate("/")
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
        
                alert(errorCode, errorMessage);
                // ..
            });


    }

    return (
        <div className='main-container-login' >
            <div className='container-login'>
                <h1> Cadastro </h1>
                <form>
                    <div className='label-login'>
                        <input
                            className='input-login'
                            type="email"
                            label="Email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Email address"
                        />
                    </div>

                    <div className='label-login'>
                        <input
                            className='input-login'
                            type="password"
                            label="Create password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Password"
                        />
                    </div>

                    <div className='label-login'>
                        <button className='btn-login' type="submit" onClick={onSubmit}>
                            Cadastrar
                        </button>
                    </div>

                </form>

                <p>
                    Já tem uma conta?{' '}
                    <NavLink to="/login" >
                        Faça login
                    </NavLink>
                </p>
            </div>
        </div>
    )
}

export default Cadastro
